var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 9.99996C1.6665 5.39758 5.39746 1.66663 9.99984 1.66663C11.3288 1.66663 12.5873 1.9783 13.704 2.5333C14.1162 2.73812 14.2843 3.23827 14.0794 3.65042C13.8746 4.06257 13.3744 4.23064 12.9623 4.02582C12.0708 3.58279 11.0657 3.33329 9.99984 3.33329C6.31794 3.33329 3.33317 6.31806 3.33317 9.99996C3.33317 13.6819 6.31794 16.6666 9.99984 16.6666C13.6818 16.6666 16.6665 13.6819 16.6665 9.99996C16.6665 9.74896 16.6527 9.50146 16.6258 9.25821C16.5752 8.80071 16.9051 8.38888 17.3625 8.33838C17.8199 8.28777 18.2318 8.61763 18.2823 9.07504C18.3159 9.37904 18.3332 9.68763 18.3332 9.99996C18.3332 14.6023 14.6022 18.3333 9.99984 18.3333C5.39746 18.3333 1.6665 14.6023 1.6665 9.99996ZM18.0891 3.57737C18.4145 3.90281 18.4145 4.43044 18.0891 4.75588L10.5891 12.2559C10.2637 12.5813 9.736 12.5813 9.41059 12.2559L6.91058 9.75588C6.58515 9.43046 6.58515 8.90279 6.91058 8.57738C7.23602 8.25193 7.76365 8.25193 8.0891 8.57738L9.99984 10.4881L16.9106 3.57737C17.236 3.25193 17.7637 3.25193 18.0891 3.57737Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.07b36207223837088f0988925cd03ffb.svg";
export { ForwardRef as ReactComponent };